import React, { useState } from 'react';

import DatePickerInput from 'components/input/DatePickerInput';
import dayjs from 'dayjs';
import { formatDateToString, formatStringToDate } from 'shared/lib';

interface MoveInModalProps {
  value: string;
  setValue: (value: string) => void;
  onClose: () => void;
}

const MoveInModal = ({ value, setValue, onClose }: MoveInModalProps) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(formatStringToDate(value));
  const today = dayjs();

  return (
    <div className="flex w-full flex-col items-center justify-center px-[55px] py-[30px]">
      <DatePickerInput
        selectedDate={selectedDate}
        setSelectedDate={(date) => {
          setSelectedDate(date);
          setValue(formatDateToString(date));
          onClose();
        }}
        hideInput
        minDate={today.add(3, 'day').toDate()}
      />
      <p className="mt-2 text-center text-c2 font-medium text-gray-40">
        Date selection is only possible from <br /> 3 days from the current date.
      </p>
    </div>
  );
};

export default MoveInModal;
